import { render, staticRenderFns } from "./ReviewAndSign.vue?vue&type=template&id=6d0f5a64"
import script from "./ReviewAndSign.vue?vue&type=script&lang=js"
export * from "./ReviewAndSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports